import React from "react";
import { Link } from "gatsby";
import useNavigationData from "@staticQueries/desktopNavigationQuery";
import { Dropdown, MobileMenuButton, NavLink } from "./";
import { Container } from "@ui";
import { KontentLink } from "./FooterLink";
import { twJoin } from "tailwind-merge";

interface HeaderProps {
  navbarStyle?: "logo_only" | "staticHeader";
}

const Header = ({ navbarStyle }: HeaderProps) => {
  const data = useNavigationData();
  const isLogoOnly = navbarStyle === "logo_only";
  const isStaticHeader = navbarStyle === "staticHeader";

  const renderSecondaryLinks = () =>
    data.secondary_links.value.map((link: KontentLink, idx: number) => (
      <NavLink
        internalPath={link.elements.internal_path.value}
        externalUrl={link.elements.external_url.value}
        target={link.elements.open_in_new_window.value[0].codename}
        secondary
        key={`secondary-link-${idx}`}
      >
        {link.elements.text.value}
      </NavLink>
    ));

  const renderMainLinks = () =>
    data.main_links.value.map((group, idx: number) => {
      // Check if the group is a dropdown
      if ("title" in group.elements) {
        return (
          <Dropdown title={group.elements.title.value} key={`dropdown-${idx}`}>
            {group.elements.links.value.map((link, linkIdx) => (
              <NavLink
                internalPath={link.elements.internal_path.value}
                externalUrl={link.elements.external_url.value}
                target={link.elements.open_in_new_window.value[0].codename}
                key={`link-${linkIdx}`}
              >
                {link.elements.text.value}
              </NavLink>
            ))}
          </Dropdown>
        );
      } else {
        // It's a simple link
        return (
          <NavLink
            internalPath={group.elements.internal_path.value}
            externalUrl={group.elements.external_url.value}
            target={group.elements.open_in_new_window.value[0].codename}
            boldText
            key={`main-link-${idx}`}
          >
            {group.elements.text.value}
          </NavLink>
        );
      }
    });

  return (
    <>
      <header
        className={twJoin(
          "z-[100] flex h-[70px] w-full items-center border-b-2 border-b-extraDarkPurple bg-warmWhite shadow-lg md:h-[85px]",
          isStaticHeader ? "relative" : "fixed",
        )}
      >
        <nav className="w-full">
          <Container
            className={twJoin(
              "flex items-center",
              isLogoOnly ? "justify-center" : "justify-between",
            )}
          >
            <Link to="/">
              <img
                src={data.logo.value[0].url}
                alt="easymoney logo"
                className="mt-2"
              />
            </Link>
            {!isLogoOnly && (
              <>
                <MobileMenuButton />
                <div className="hidden flex-col items-end gap-[6px] md:flex">
                  <div className="flex gap-6">{renderSecondaryLinks()}</div>
                  <div className="flex gap-6">{renderMainLinks()}</div>
                </div>
              </>
            )}
          </Container>
        </nav>
      </header>
      {!isStaticHeader && <div className="mb-[70px] md:mb-[86px]" />}
    </>
  );
};

export default Header;
